import { DictionaryValue } from '../models/classes/dictionary/dictionaryValue';
import { Dictionary } from '../models/classes/dictionary/dictionary';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { Site } from '@classes/site';

@Injectable({
  providedIn: 'root'
})
export class DictionaryValuesService {
  dictionaryValuesListChanged = new Subject<DictionaryValue[]>();
  transportTypesListChanged = new Subject<DictionaryValue[]>();
  urgencyLevelsListChanged = new Subject<DictionaryValue[]>();
  private urlTransport: string = environment.apiUrl + 'dictionaries/transport-types/values';
  private urlBase: string = environment.apiUrl + 'values';
  private urlUrgency: string = environment.apiUrl + 'dictionaries/urgency-levels/values';
  private dictionaryValues: DictionaryValue[];
  private transportTypes: DictionaryValue[];
  private urgencyLevels: DictionaryValue[];

  constructor(
    private http: HttpClient
  ) { }

  getList(): Observable<DictionaryValue[]> {
    return this.http.get<DictionaryValue[]>(`${this.urlBase}`)
      .pipe(
        map(dictionaryValues => {
          this.dictionaryValues = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          this.dictionaryValuesListChanged.next([...this.dictionaryValues]);
          return [...this.dictionaryValues];
        })
      );
  }

  getTransportList(): Observable<DictionaryValue[]> {
    return this.http.get<DictionaryValue[]>(`${this.urlTransport}`)
      .pipe(
        map(dictionaryValues => {
          this.transportTypes = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          // this.transportTypes = this.transportTypes.filter(t => t.dictionary.code === 'transport-types');
          this.transportTypes.sort((a, b) => a.name.localeCompare(b.name));
          this.transportTypesListChanged.next([...this.transportTypes]);
          return [...this.transportTypes];
        })
      );
  }

  public getTransportListBySite({ id }: Site, clientId?: string) {
    return this.http.get<DictionaryValue[]>(`${this.urlTransport}?siteId=${id}${clientId ? `&clientId=${clientId}` : ''}`)
      .pipe(
        map(dictionaryValues => {
          this.transportTypes = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          this.transportTypes.sort((a, b) => a.name.localeCompare(b.name));
          this.transportTypesListChanged.next([...this.transportTypes]);
          return [...this.transportTypes];
        })
      );
  }

  getUrgencyList(): Observable<DictionaryValue[]> {
    return this.http.get<DictionaryValue[]>(`${this.urlUrgency}`)
      .pipe(
        map(dictionaryValues => {
          this.urgencyLevels = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          // this.urgencyLevels = this.urgencyLevels.filter(u => u.dictionary.code === 'urgency-levels');
          this.urgencyLevels.sort((a, b) => a.name.localeCompare(b.name));
          this.urgencyLevelsListChanged.next([...this.urgencyLevels]);
          return [...this.urgencyLevels];
        })
      );
  }

  public getUrgencyListBySite({ id }: Site, clientId?: string) {
    return this.http.get<DictionaryValue[]>(`${this.urlUrgency}?siteId=${id}${clientId ? `&clientId=${clientId}` : ''}`)
      .pipe(
        map(dictionaryValues => {
          this.urgencyLevels = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          this.urgencyLevels.sort((a, b) => a.name.localeCompare(b.name));
          this.urgencyLevelsListChanged.next([...this.urgencyLevels]);
          return [...this.urgencyLevels];
        })
      );
  }

  getTransportListById(id: string): Observable<DictionaryValue[]> {
    return this.http.get<DictionaryValue[]>(`${this.urlBase}?clientId=${id}`)
      .pipe(
        map(dictionaryValues => {
          this.transportTypes = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          this.transportTypes = this.transportTypes.filter(t => t.dictionary.code === 'transport-types');
          this.transportTypes.sort((a, b) => a.name.localeCompare(b.name));
          this.transportTypesListChanged.next([...this.transportTypes]);
          return [...this.transportTypes];
        })
      );
  }

  getUrgencyListById(id: string): Observable<DictionaryValue[]> {
    return this.http.get<DictionaryValue[]>(`${this.urlBase}?clientId=${id}`)
      .pipe(
        map(dictionaryValues => {
          this.urgencyLevels = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          this.urgencyLevels = this.urgencyLevels.filter(u => u.dictionary.code === 'urgency-levels');
          this.urgencyLevels.sort((a, b) => a.name.localeCompare(b.name));
          this.urgencyLevelsListChanged.next([...this.urgencyLevels]);
          return [...this.urgencyLevels];
        })
      );
  }

  getTransportListById2(id: string): Observable<DictionaryValue[]> {
    return this.http.get<DictionaryValue[]>(`${this.urlTransport}?clientId=${id}`)
      .pipe(
        map(dictionaryValues => {
          this.transportTypes = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          this.transportTypes.sort((a, b) => a.name.localeCompare(b.name));
          this.transportTypesListChanged.next([...this.transportTypes]);
          return [...this.transportTypes];
        })
      );
  }

  getUrgencyListById2(id: string): Observable<DictionaryValue[]> {
    return this.http.get<DictionaryValue[]>(`${this.urlUrgency}?clientId=${id}`)
      .pipe(
        map(dictionaryValues => {
          this.urgencyLevels = dictionaryValues.map(c => DictionaryValue.fromObject(c));
          this.urgencyLevels.sort((a, b) => a.name.localeCompare(b.name));
          this.urgencyLevelsListChanged.next([...this.urgencyLevels]);
          return [...this.urgencyLevels];
        })
      );
  }

  putTransportType(dictionaryValue: DictionaryValue): Observable<DictionaryValue> {
    return this.http.put<DictionaryValue>(this.urlBase, dictionaryValue)
      .pipe(
        tap(editedDictionaryValue => {
          editedDictionaryValue = DictionaryValue.fromObject(editedDictionaryValue);
          this.transportTypes = this.transportTypes.map(c => c.id === editedDictionaryValue.id ? editedDictionaryValue : c);
          this.transportTypesListChanged.next([...this.transportTypes]);
        })
      );
  }

  putUrgencyLevel(dictionaryValue: DictionaryValue): Observable<DictionaryValue> {
    return this.http.put<DictionaryValue>(this.urlBase, dictionaryValue)
      .pipe(
        tap(editedDictionaryValue => {
          editedDictionaryValue = DictionaryValue.fromObject(editedDictionaryValue);
          this.urgencyLevels = this.urgencyLevels.map(c => c.id === editedDictionaryValue.id ? editedDictionaryValue : c);
          this.urgencyLevelsListChanged.next([...this.urgencyLevels]);
        })
      );
  }
  postTransportType(dictionaryValue: DictionaryValue): Observable<DictionaryValue> {
    return this.http.post<DictionaryValue>(this.urlBase, dictionaryValue)
      .pipe(
        tap(createdDictionaryValue => {
          createdDictionaryValue = DictionaryValue.fromObject(createdDictionaryValue);
          this.transportTypes.push(createdDictionaryValue);
          this.transportTypesListChanged.next([...this.transportTypes]);
        })
      );
  }

  postUrgencyLevel(dictionaryValue: DictionaryValue): Observable<DictionaryValue> {
    return this.http.post<DictionaryValue>(this.urlBase, dictionaryValue)
      .pipe(
        tap(createdDictionaryValue => {
          createdDictionaryValue = DictionaryValue.fromObject(createdDictionaryValue);
          this.urgencyLevels.push(createdDictionaryValue);
          this.urgencyLevelsListChanged.next([...this.urgencyLevels]);
        })
      );
  }

  deleteTypeTransport(id: string): Observable<void> {
    return this.http.delete<void>(`${this.urlBase}/${id}`)
      .pipe(
        tap(() => {
          this.transportTypes = this.transportTypes.filter(m => m.id !== id);
          this.transportTypesListChanged.next([...this.transportTypes]);
        })
      );
  }

  deleteUrgencyLevel(id: string): Observable<void> {
    return this.http.delete<void>(`${this.urlBase}/${id}`)
      .pipe(
        tap(() => {
          this.urgencyLevels = this.urgencyLevels.filter(m => m.id !== id);
          this.urgencyLevelsListChanged.next([...this.urgencyLevels]);
        })
      );
  }

  compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }


}
